import { Outlet } from "react-router";


export function Main({ children } : React.PropsWithChildren) {
    return (
        <main>
            <Outlet />
        </main>
    )
}